import Swiper, { Navigation, Pagination,Scrollbar,EffectFade, Autoplay } from 'swiper';

const Swipers = () => {
    const isSanita = document.body.classList.contains('sanita');
    const isCorporate = document.body.classList.contains('corporate');
    
    // Inizializza tutti gli swiper news/events
    let allSwiperNewsEvents = document.querySelectorAll('.swiper_news_events');
    allSwiperNewsEvents.forEach(element => {
        new Swiper(element, {        
            // configure Swiper to use modules
            modules: [Scrollbar, Navigation],
            slidesPerView: isSanita || isCorporate ? 1.1 : 1,
            spaceBetween: isSanita || isCorporate ? 24 : 10,
            scrollbar: {
                el: element.querySelector(".swiper-scrollbar"),
                hide: false,
                draggable: true,
                dragSize: 100
            },
            // Responsive breakpoints
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                990: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 3
                }
            },
            navigation: {
                nextEl: element.querySelector('.swiper-navigation-next'),
                prevEl: element.querySelector('.swiper-navigation-prev'),
            },
            on: {
                imagesReady: function(e){
                    this.el.classList.add('loaded');
                }
            }
        });
    });

    // Inizializza tutti gli swiper news/events
    let allSwiperCardGrid = document.querySelectorAll('.card-carousel');
    allSwiperCardGrid.forEach(element => {
        new Swiper(element, {        
            // configure Swiper to use modules
            modules: [Scrollbar, Navigation],
            slidesPerView: 1.1 ,
            spaceBetween: 24,
            scrollbar: {
                el: element.querySelector(".swiper-scrollbar"),
                hide: false,
                draggable: true,
                dragSize: 100
            },
            // Responsive breakpoints
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                990: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                }
            },
            navigation: {
                nextEl: element.querySelector('.swiper-navigation-next'),
                prevEl: element.querySelector('.swiper-navigation-prev'),
            },
            on: {
                imagesReady: function(e){
                    this.el.classList.add('loaded');
                }
            }
        });
    });

    const swiperStakeholder = new Swiper('.swiper-stakeholder', {
        // configure Swiper to use modules
        modules: [Scrollbar],

        slidesPerView: 1,
        spaceBetween: 10,
        scrollbar: {
            el: ".swiper-stakeholder .swiper-scrollbar",
            hide: false,
            draggable: true,
            dragSize: 100
        },
        // navigation: {
        //     nextEl: ".holder-next",
        //     prevEl: ".holder-prev",
        // },
        // Responsive breakpoints
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3.5,
            }
        },
    });
    
    const swiperStrutture = new Swiper('.swiper-related-strutture', {
        modules: [Scrollbar],
        scrollbar: {
            el: ".swiper-related-strutture .swiper-scrollbar",
            hide: false,
            draggable: true,
            dragSize: 100
        },
        autoplay: true,
        disableOnInteraction: true,
        spaceBetween: 20,
        slidesPerView: 1,
        freeMode: true,
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3
            },
            1200: {
                slidesPerView: 4
            }
        },
    });

    const swiperCatfilter = new Swiper('.swiper-categories-filters', {
        modules: [Scrollbar],
        scrollbar: {
            el: ".swiper-categories-filters .swiper-scrollbar",
            hide: false,
            draggable: true,
            dragSize: 100
        },
        autoplay: true,
        disableOnInteraction: true,
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        //centeredSlides: true,
        breakpoints: {
            576: {
                slidesPerView: 3,
            },
            990: {
                slidesPerView: 4
            },
            1200: {
                slidesPerView: 6
            }
        },
    });

    let allSwiperAutowidth = document.querySelectorAll('.carousel-autowidth');
    allSwiperAutowidth.forEach(element => {
        const oneSliderId = element.getAttribute('id');
        return new Swiper('#'+oneSliderId+' .swiper-autowidth', {
            modules: [Scrollbar, Navigation],
            scrollbar: {
                el: '#'+oneSliderId+' .swiper-scrollbar',
                hide: false,
                draggable: true,
                dragSize: 100
            },
            autoplay: true,
            disableOnInteraction: true,
            spaceBetween: 20,
            slidesPerView: 2,
            freeMode: true,
            navigation: {
                nextEl: '#'+oneSliderId+' .swiper-button-next',
                prevEl: '#'+oneSliderId+' .swiper-button-prev',
            },
            breakpoints: {
                990: {
                    spaceBetween: 20,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 20,
                    slidesPerView: 5
                }
            }
        });
    });

    const swiperPageHero = new Swiper('.swiper-page-hero', {
        modules: [Pagination, EffectFade, Autoplay, Navigation],
        slidesPerView: 1,
        effect: "fade",
        autoHeight: true,
        pagination: {
            el: ".swiper-page-hero .swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">0' + (index + 1) + ".</span>";
              },
        },
        navigation: {
            nextEl: ".swiper-page-hero .swiper-button-next",
          },
        autoplay: {
            enabled: false,
            delay: 3000,
            disableOnInteraction: true,
        },
        breakpoints: {
            990: {
                autoplay: {
                    enabled: true
                }
            },
        },
    });

    const breakpoint = window.matchMedia( '(min-width:992px)' );

    // keep track of swiper instances to destroy later
    let servicesWall;
    let sideCardBanner;
    let newsWall;
    let onlyMobileCarousels = []; // Array per tenere traccia di tutti i caroselli mobile

    const breakpointChecker = function() {
        // if larger viewport and multi-row layout needed
        if ( breakpoint.matches === true ) {
            // clean up old instances and inline styles when available
            if ( servicesWall !== undefined ) {
                servicesWall.destroy( true, true );
            }
            if ( sideCardBanner !== undefined ){
                sideCardBanner.destroy( true, true );
            }
            if ( newsWall !== undefined ){
                newsWall.destroy( true, true );
            }
            onlyMobileCarousels.forEach(carousel => carousel.destroy(true, true));
            onlyMobileCarousels = [];

            return;
            // else if a small viewport and single column layout needed
            
        } else {
            if ( document.querySelector('.listing-news-grid-wrapper')) {
                // fire small viewport version of swiper
                mobileNewsWall();
            }
            if ( document.querySelector('.services-wall-grid')) {
                // fire small viewport version of swiper
                mobileServicesWall();
            }
            if ( document.querySelector('.services-wall-grid.--count-x3')) {
                // fire small viewport version of swiper
                mobileServicesWall3();
            }
            if  ( document.querySelector('.side-banner-swiper') ) {
                mobileSideCardBanner();
            }

            mobileOnlyMobileCarousels();
            
            
        }
    };
    const mobileNewsWall = function() {

        newsWall = new Swiper('.listing-news-grid-wrapper', {
            modules: [Pagination],
            autoplay: true,
            disableOnInteraction: true,
            spaceBetween: 10,
            slidesPerView: 1,
            freeMode: true,
            pagination: {
                el: '.listing-news-grid-wrapper .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                650: {
                    slidesPerView: 2,
                },
                990: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        })
    }
    const mobileServicesWall = function() {
       
        servicesWall = new Swiper('.services-wall-grid', {
            modules: [Pagination],
            autoplay: true,
            disableOnInteraction: true,
            spaceBetween: 20,
            slidesPerView: 1,
            freeMode: true,
            pagination: {
                el: '.services-wall-grid .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                650: {
                    slidesPerView: 2,
                },
                990: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        })
        
    }
    const mobileServicesWall3 = function() {
       
        servicesWall = new Swiper('.services-wall-grid.--count-x3', {
            modules: [Scrollbar],
            autoplay: true,
            disableOnInteraction: true,
            spaceBetween: 20,
            slidesPerView: isCorporate ? 1.1 : 1,
            freeMode: true,
            scrollbar: {
                el: ".services-wall-grid.--count-x3 .swiper-scrollbar",
                hide: false,
                draggable: true,
                dragSize: 100
            },
            breakpoints: {
                650: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3
                }
            }
        })
        
    }
    const mobileSideCardBanner = function() {
        sideCardBanner = new Swiper('.side-banner-swiper', {
            modules: [Scrollbar],
            autoplay: true,
            disableOnInteraction: true,
            spaceBetween: 20,
            slidesPerView: 1,
            freeMode: true,
            scrollbar: {
                el: ".side-banner-swiper .swiper-scrollbar",
                hide: false,
                draggable: true,
                dragSize: 100
            }
        })
    }

    const mobileOnlyMobileCarousels = function() {
        const carouselElements = document.querySelectorAll('.only-mobile-carousel-wrapper');
        

        carouselElements.forEach((element) => {
            var id = element.id;
            const carousel = new Swiper(`#${id} .only-mobile-carousel`, {
                modules: [Pagination],
                slidesPerView: 1,
                spaceBetween: 10,
                pagination: {
                    el: `#${id} .swiper-pagination`,
                    clickable: true
                },
            });
            
            // Aggiungi il carosello all'array
            onlyMobileCarousels.push(carousel);
        });
    };

    // keep an eye on viewport size changes
    breakpoint.addEventListener('change', function (e){
        // kickstart
        breakpointChecker();
    })
    breakpointChecker();


    const swiperGallery = new Swiper('.swiper-gallery', {
        modules: [Scrollbar],
        scrollbar: {
            el: ".swiper-gallery .swiper-scrollbar",
            hide: false,
            draggable: true,
            dragSize: 100
        },
        spaceBetween: 20,
        slidesPerView: 1,
        freeMode: true,
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3
            },
            1200: {
                slidesPerView: 3
            }
        },
    });
    const blkVideoCarousel = function() {
        let video = document.querySelectorAll('.video-carousel .swiper-slide');
        let countSlide = 2;
        if (video.length >= 3){
            countSlide = 3;
        }
        new Swiper('.video-carousel', {
            spaceBetween: 20,
            modules: [Scrollbar],
            slidesPerView: 1,
            freeMode: true,
            scrollbar: {
                el: ".video-carousel .swiper-scrollbar",
                hide: false,
                draggable: true,
                dragSize: 100
            },
            breakpoints: {
                990: {
                    slidesPerView: countSlide
                },
            },
        });
    };
    if(document.querySelector('.video-carousel')){
        blkVideoCarousel();
    }

    const pageHeaderGallery = new Swiper('.page-header-gallery', {
        modules: [Scrollbar, Navigation],
        autoplay: true,
        disableOnInteraction: true,
        spaceBetween: 10,
        slidesPerView: 1,
        freeMode: true,
        scrollbar: {
            el: ".page-header-gallery .swiper-scrollbar",
            hide: false,
            draggable: true,
            dragSize: 100
        },
        navigation: {
            nextEl: document.querySelector('.page-header-gallery .swiper-navigation-next'), //document.parentElement.querySelector('.swiper-button-next')
            prevEl: document.querySelector('.page-header-gallery .swiper-navigation-prev'), //element.parentElement.querySelector('.swiper-button-prev')
        },
        centeredSlides: true,
        breakpoints: {
            990: {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 2,
                centeredSlides: false,
                spaceBetween: 20,
            }
        }
    })

    const swiperCarouselNews = new Swiper('.swiper-news-carousel__wrapper .swiper-news-carousel', {
        modules: [Scrollbar],
        scrollbar: {
            el: ".swiper-news-carousel__wrapper .swiper-scrollbar",
            hide: false,
            draggable: true,
            dragSize: 100
        },
        autoplay: true,
        disableOnInteraction: true,
        spaceBetween: 20,
        slidesPerView: 1,
        freeMode: true,
        breakpoints: {
            576: {
                slidesPerView: 2,
            }
        },
    });

    const swiperOpenday = new Swiper('.swiper-openday', {
        modules: [Navigation, Pagination],
        spaceBetween: 30,
        slidesPerView: 1.2,
        freeMode: true,
        pagination: {
            el: '.swiper-openday .swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: document.querySelector('.swiper-openday .swiper-navigation-next'), //document.parentElement.querySelector('.swiper-button-next')
            prevEl: document.querySelector('.swiper-openday .swiper-navigation-prev'), //element.parentElement.querySelector('.swiper-button-prev')
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3
            },
            1200: {
                slidesPerView: 4
            }
        },
    });
}

export default Swipers;
